/* 🤖 this file was generated by svg-to-ts */
export const iconHyperpaywallet: {
  name: 'hyperpaywallet';
  data: string;
} = {
  name: 'hyperpaywallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="#3770F4" d="M16 0C7.17 0 0 7.17 0 16s7.17 15.96 16 15.96 16-7.17 16-16S24.83 0 16 0m4.22 19.46c-1.07 0-3.71.04-3.71.04l-1.19 4.61h-4.95l1.15-4.52H3.8l1.24-3.71s13.44.04 14.55 0 2.82-.3 2.86-2.52c.04-3.03-4.61-2.86-4.99-.17-.26 1.71-.26 2.13-.26 2.13h-4.39l.85-4.01H6.53L7.6 7.56s10.45.04 12.42.04 7.21.51 7.21 5.33c0 5.29-5.08 6.53-7 6.53z"/></svg>`,
};
